/*
  Due to bundling in `mggp-player-loader` make all necessary code transformation itself,
  via includes all mggp-packages/dist/*.js
  we should not care to how and what we really expose in that package
 */
module.exports = require('../src/mggp-vendor-hls');
